// avg character width
const CHARACTER_WIDTH_PX = 7;
const SLASH_WIDTH_PX = 4;
const ROOT_ICON_WIDTH_PX = 20;
/** Gap between the flex items of the path row (`gap="2xs"` → `--ds-2xs` = 2px). */
const ITEM_GAP_PX = 2;
const MAX_LINES = 2;
export const PATH_ELLIPSIS = '...';
const getTextWidth = (text) => text.length * CHARACTER_WIDTH_PX;
const getItemWidths = (rootName, segments) => {
    const rootWidth = ROOT_ICON_WIDTH_PX + getTextWidth(rootName);
    return [
        rootWidth,
        ...segments.flatMap((segment) => [
            SLASH_WIDTH_PX,
            getTextWidth(segment),
        ]),
    ];
};
const fitsWithinLines = (itemWidths, containerWidth, maxLines = MAX_LINES) => {
    let lines = 1;
    // The first item opens the first line with no leading gap.
    let lineWidth = itemWidths[0] ?? 0;
    for (let index = 1; index < itemWidths.length; index += 1) {
        const itemWidth = itemWidths[index] ?? 0;
        if (lineWidth + ITEM_GAP_PX + itemWidth <= containerWidth) {
            lineWidth += ITEM_GAP_PX + itemWidth;
            continue;
        }
        lines += 1;
        lineWidth = itemWidth;
        if (lines > maxLines) {
            return false;
        }
    }
    return true;
};
export const getVisiblePathSegments = ({ containerWidth, maxLines = MAX_LINES, restSegments, rootName, }) => {
    // Before the container is measured (or with nothing to truncate) show all.
    if (containerWidth <= 0 || restSegments.length === 0) {
        return restSegments;
    }
    if (fitsWithinLines(getItemWidths(rootName, restSegments), containerWidth, maxLines)) {
        return restSegments;
    }
    let kept = [];
    for (let start = restSegments.length - 1; start >= 0; start -= 1) {
        const candidate = restSegments.slice(start);
        if (!fitsWithinLines(getItemWidths(rootName, [PATH_ELLIPSIS, ...candidate]), containerWidth, maxLines)) {
            break;
        }
        kept = candidate;
    }
    // The deepest segment must stay visible even if it alone overflows.
    if (kept.length === 0) {
        kept = restSegments.slice(-1);
    }
    return [PATH_ELLIPSIS, ...kept];
};
